
/*
 * SIMPLY PENCILS
 * PEN HERO IMAGE SELECTOR
 * Version 1.0 - October 2026
 *
 * Changes the displayed pen hero based on Pen Color.
 *
 * Only affects images tagged SP-PEN-HERO-*.
 * All other gallery images remain untouched.
 *
 * Does not change prices, variants, engraving
 * selections, or cart properties.
 */

(() => {
  if (window.__spPenHeroLoaded) return;
  window.__spPenHeroLoaded = true;

  const HERO_PREFIX = 'SP-PEN-HERO-';

  const COLORS = {
    'All Five Colors': 'MIX',
    'Black': 'BLACK',
    'Blue': 'BLUE',
    'Burgundy': 'BURGUNDY',
    'Green': 'GREEN',
    'Red': 'RED'
  };

  function heroColor(element) {
    const image = element.querySelector('img');
    const alt = image?.getAttribute('alt') || '';

    const match = alt.toUpperCase().match(
      /SP-PEN-HERO-(MIX|BLACK|BLUE|BURGUNDY|GREEN|RED)/
    );

    return match ? match[1] : null;
  }

  function getSelectedColor(select) {
    return COLORS[select.value] || 'MIX';
  }

  function updateGallery(select) {
    const section = select.closest('.shopify-section');
    if (!section) return;

    const gallery = section.querySelector('media-gallery');
    if (!gallery) return;

    const viewer = gallery.querySelector(
      '[id^="GalleryViewer-"]'
    );

    if (!viewer) return;

    const slides = [
      ...viewer.querySelectorAll(
        'li.product__media-item[data-media-id]'
      )
    ];

    const thumbnails = [
      ...gallery.querySelectorAll(
        '[id^="GalleryThumbnails-"] li[data-target]'
      )
    ];

    const requestedColor = getSelectedColor(select);

    const availableColors = slides
      .map(heroColor)
      .filter(Boolean);

    if (!availableColors.length) return;

    const activeColor = availableColors.includes(requestedColor)
      ? requestedColor
      : availableColors.includes('MIX')
        ? 'MIX'
        : availableColors[0];

    let activeMediaId = null;

    // Show only the chosen hero slide.
    slides.forEach(slide => {
      const color = heroColor(slide);
      if (!color) return;

      const show = color === activeColor;

      slide.style.display = show ? '' : 'none';

      if (show) {
        activeMediaId = slide.dataset.mediaId;
      }
    });

    // Show only the chosen hero thumbnail.
    thumbnails.forEach(thumbnail => {
      const color = heroColor(thumbnail);
      if (!color) return;

      const show = color === activeColor;

      thumbnail.style.display = show ? '' : 'none';

      if (!show) {
        thumbnail.querySelector('button')
          ?.removeAttribute('aria-current');
      }
    });

    // Activate the selected hero in Shopify's gallery.
    if (
      activeMediaId &&
      typeof gallery.setActiveMedia === 'function'
    ) {
      gallery.setActiveMedia(activeMediaId, false);
    }

    // Keep the mobile slide counter accurate.
    const visibleSlides = slides.filter(
      slide => slide.style.display !== 'none'
    );

    const counter = gallery.querySelector(
      '.slider-counter--total'
    );

    if (counter) {
      counter.textContent = visibleSlides.length;
    }

    // Keep the modal's alternate hero images hidden.
    const modal = section.querySelector(
      'product-modal'
    );

    if (modal) {
      modal.querySelectorAll(
        '[data-media-id]'
      ).forEach(item => {
        const color = heroColor(item);
        if (!color) return;

        item.style.display =
          color === activeColor ? '' : 'none';
      });
    }
  }

  function initialize() {
    document.querySelectorAll(
      'select[id^="sp-pen-color-"]'
    ).forEach(updateGallery);
  }

  document.addEventListener('change', event => {
    const select = event.target.closest(
      'select[id^="sp-pen-color-"]'
    );

    if (select) updateGallery(select);
  });

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialize
    );
  } else {
    initialize();
  }

  document.addEventListener(
    'shopify:section:load',
    initialize
  );
})();
